import { SLIDES_LIST_HEADER_HEIGHT } from 'components/OrderSlidesList/OrderSlidesListViewV2Styles';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  actionsContainer: {
    display: 'grid',
    gridTemplateRows: '50% 50%',
    gap: '0.75rem',
    height: '100%',
    maxHeight: `calc(100vh - ${SLIDES_LIST_HEADER_HEIGHT} - 0.75rem)`,

    '&.slideList': {
      gridTemplateRows: '100%',
    },
  },
});

export const usePanelCollapseHandleStyles = makeStyles()((theme) => ({
  handle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.35rem',
    width: '100%',
    height: '100%',
    minHeight: '12rem',
    padding: '0.6rem 0',
    borderRadius: '0.4rem',
    color: theme.palette.text.secondary,
    fontSize: '1.1rem',
    transition: 'background 120ms ease-out, color 120ms ease-out',
    '&:hover': {
      background: theme.palette.grey[200],
      color: theme.palette.text.primary,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.light}`,
      outlineOffset: '-2px',
    },
  },
  handleCollapsed: {
    background: theme.palette.grey[100],
    color: theme.palette.primary.dark,
    '&:hover': {
      background: theme.palette.primary.light,
      color: theme.palette.common.white,
    },
  },
  icon: {
    fontSize: '1.2rem',
  },
  label: {
    writingMode: 'vertical-rl',
    fontSize: '0.62rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    lineHeight: 1,
    userSelect: 'none',
  },
}));
